// AUTO-GENERATED by scripts/gen-content-meta.ts — do not edit by hand.
export const EN_INSIGHT_PAIRS: Record<string, string> = {
  "foreign-tax-residency-thailand-2026": "foreign-tax-residency-thailand-tin-ro22-guide",
  "property-transfer-poa-thailand-2026": "thailand-property-transfer-poa-guide",
  "smart-visa-boi-thailand-2026": "smart-visa-boi-thailand-guide",
  "re-entry-permit-thailand-2026": "thailand-re-entry-permit-guide",
  "police-clearance-by-country-2026": "police-clearance-by-destination-country",
  "guardian-visa-thailand-2026": "guardian-visa-thailand-complete-guide",
  "e-extension-90day-online-2026": "thailand-e-extension-90-day-report-online-guide",
  "e-work-permit-online-2026": "e-work-permit-thailand-digital-system-guide",
  "non-b-visa-thailand-2026": "non-b-business-visa-thailand-complete-guide",
  "retirement-visa-thailand-2026": "thailand-retirement-visa-non-o-oa-ox-guide",
  "marriage-visa-thailand-2026": "thai-marriage-visa-non-o-guide",
  "work-permit-salary-by-nationality-2026": "thailand-work-permit-minimum-salary-by-nationality",
  "overstay-blacklist-thailand-2026": "thailand-overstay-blacklist-guide",
  "permanent-residence-thai-citizenship-2026": "thailand-permanent-residence-citizenship-guide",
  "sell-us-property-from-thailand": "sell-us-property-from-thailand-remote-closing-playbook",
  "thai-driving-license-conversion": "thai-driving-license-conversion-by-country",
  "wise-revolut-thai-banking": "wise-revolut-thai-bank-compliance-guide",
  "thailand-condo-foreign-quota": "thailand-condo-foreign-quota-fet-guide",
  "thailand-privilege-visa-2026": "thailand-privilege-visa-2026-tiers-explained",
  "e-visa-thailand-2026-complete-guide": "thailand-e-visa-2026-complete-guide",
  "tm6-arrival-card-thailand-2026": "tdac-thailand-digital-arrival-card-2026",
  "notarial-services-attorney": "notarial-services-attorney-thailand-explained",
  "dtv-tax-residency-thailand": "dtv-holder-tax-residency-thailand-2026",
  "fbi-background-check-thailand": "fbi-background-check-from-thailand-complete-guide",
  "thai-will-vs-foreign-will": "thai-will-vs-foreign-will-expat-estate-planning",
  "sworn-vs-certified-translator-thailand": "sworn-vs-certified-translator-thailand-decision-guide",
  "foreign-property-ownership-thailand": "buying-property-in-thailand-foreigner-legal-guide",
  "ltr-visa-thailand-2026-guide": "ltr-visa-thailand-complete-guide",
  "poa-jurisdiction-map-thailand": "notarized-poa-abroad-jurisdiction-map",
  "company-formation-thailand-foreigner": "thailand-company-formation-foreigner-guide-2026",
  "tm30-90day-reporting": "tm30-90-day-reporting-thailand-expat-guide",
  "police-clearance-thailand-2026-guide": "police-clearance-thailand-expat-complete-guide",
  "naati-translation-thailand": "naati-certified-translation-thailand-australia-visa",
  "best-amphur-marriage-thailand": "best-amphur-to-marry-in-thailand-expat-comparison",
  "dtv-vs-ltr-vs-thailand-privilege-comparison": "dtv-vs-ltr-vs-thailand-privilege-elite-visa-comparison-2026",
  "phuket-translation-service-guide": "certified-translation-thailand-guide",
  "work-permit-thailand-2026-guide": "work-permit-thailand-foreigner-complete-guide",
  "marriage-foreigner-guide": "marry-in-thailand-foreigner-complete-guide",
  "dtv-visa-explained": "dtv-visa-thailand-digital-nomad-complete-guide",
  "mfa-legalization-step-by-step": "mfa-legalization-thailand-step-by-step",
  "notary-public-thailand-complete-guide": "notary-public-thailand-expat-guide",
  "mfa-vs-apostille": "apostille-thailand-2026-complete-guide"
};

export function getEnInsightSlugForThaiSlug(thaiSlug: string): string | undefined {
  return EN_INSIGHT_PAIRS[thaiSlug];
}
